import { useAuth0 } from "@auth0/auth0-react";

export const useBasecampRoles = (): string[] => {
  const { user } = useAuth0();
  const rolesKey = `${import.meta.env.VITE_AUTH0_CLAIM_NAMESPACE}/roles`;
  const claim = user?.[rolesKey];
  if (!claim) return [];
  if (Array.isArray(claim)) return claim.map((r: string) => r.trim());
  return String(claim)
    .split(",")
    .map((r) => r.trim());
};
